import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Action';
// import Select from 'react-select';
import { bindActionCreators } from 'redux';
import SelectComp from "../../NewComponent/Select/Select";

export default function SelectMonthsDurationForTrendingSearch() {
	const userState = useSelector((state) => state.user);
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const dispatch = useDispatch();
	const { getMonthsDurationInTrendingSeach, getTotalCount } = bindActionCreators(Actions, dispatch);
	const array1 = [
		{ label: 'Last Month', value: null },
		{ label: 'Last 3 Months', value: '3months' }
		, { label: 'Last 6 months', value: '6months' },
		{ label: 'Last 1 Year', value: '12months' },
		{ label: 'Year To Date', value: '-1months' }
	]
	// console.log(expertOverview,'check expert overview')

	const customStyles = {
		control: (base, state) => ({
			...base,
			fontSize: 13,
			marginBottom:5,
			minHeight: 32,
			height: 32,
			borderColor: state.isFocused ? 'none' : null,
			minWidth: 120,
			border: '1px solid lightgrey',
			boxShadow: 'none',
			border: state.isFocused ? '1px solid lightgrey' : '1px solid lightgrey',
			"&:hover": { border: '1px solid lighgrey' }
		}),
		menuList: (base) => ({
			...base,
			fontSize: 13,
			padding: 0
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: (state.isSelected && 'var(--viz_light_color)'),
			"&:hover": { backgroundColor: state.isSelected ? null : '#ececec' },
			cursor: 'pointer'
		}),
		dropdownIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
		  clearIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
	};

	const onChangeData = (data) => {
		getMonthsDurationInTrendingSeach(data)
		getTotalCount()
	}
	return (
		<>
			{/* <Select
				className="basic-single"
				classNamePrefix="select"
				defaultValue={array1[0]}
				isDisabled={false}
				isClearable={false}
				isSearchable={true}
				name="color"
				options={array1}
				styles={customStyles}
				onChange={onChangeData}
			/> */}
			<SelectComp val={expertOverview.trendingSearchDuration} isString={false} width={'100%'} labelInValue={true} onChangeFunc={onChangeData} options={array1} />
		</>
	)
}